import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Slide } from "@mui/material";
import "./Snackbar.scss";

interface snackbarMsg {
  message: string;
  isToggle: boolean;
  mode: string;
  top?: string;
  right?: string;
}

interface Props {
  isOpenSnack: snackbarMsg;
  setIsOpenSnack: React.Dispatch<React.SetStateAction<snackbarMsg>>;
}
const GlobalSnackBar = (props: Props) => {
  const { isOpenSnack, setIsOpenSnack } = props;
  let bgColor: string = "";
  let color: string = "";
  switch (isOpenSnack.mode) {
    case "error":
      color = "#81222C";
      bgColor = "#F7D5D8";
      break;
    case "warning":
      color = "#8F6D06";
      bgColor = "#FAEFC9";
      break;
    case "success":
      color = "#165C27";
      bgColor = "#D0E7D6";
      break;
  }

    useEffect(() => {
        const timer = setTimeout(() => { setIsOpenSnack({ message: '', isToggle: false, mode: '' }) }, 3000);
        return () => clearTimeout(timer);
    }, [isOpenSnack]);

  return (
    <Slide
      direction="left"
      in={isOpenSnack.isToggle}
      mountOnEnter
      unmountOnExit
      timeout={800}
    >
      <Box
        className="snack-bar border-radius-4  fw-500"
        sx={{
          fontSize: { md: "15px", xs: "12px" },
          background: bgColor,
          color: color,
          top: isOpenSnack.top ? isOpenSnack.top : "80px",
          right: isOpenSnack.right ? isOpenSnack.right : "30px",
        }}
      >
        <div className="title">{isOpenSnack.message}</div>
        <div className="action">
          <CloseIcon
            sx={{
              cursor: "pointer",
              fontSize: "18px",
              mt: 0.6,
              fontWeight: 500,
            }}
            onClick={() =>
              setIsOpenSnack({ message: "", isToggle: false, mode: "" })
            }
          />
        </div>
      </Box>
    </Slide>
  );
};

export default GlobalSnackBar;
